var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.appEngineEnabled)?_c('div',{staticClass:"app-container"},[_c('AppSidebar'),_c('div',{staticClass:"app-content"},[_c('router-view')],1)],1):_c('div',[_c('b-message',{attrs:{"title":_vm.$t('appengine-not-enabled-title'),"type":"is-info"}},[_vm._v(" "+_vm._s(_vm.$t('appengine-not-enabled-description'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }